<div class="content">
    <div class="grids">
        <igx-grid primaryKey="id" [data]="sports | sorting" [width]="'100%'" [height]="'250px'"
            (selected)="sportSelected($event)">
            <igx-grid-toolbar>
                <igx-grid-toolbar-title>Спортове</igx-grid-toolbar-title>
                <igx-grid-toolbar-actions>
                    <button igxButton igxRipple (click)="openSportDialog(sportDialog)">Добави спорт</button>
                </igx-grid-toolbar-actions>
            </igx-grid-toolbar>
            <igx-column width="50px" [editable]="false" [resizable]="false" [pinned]="true">
                <ng-template igxCell let-cell="cell">
                    <button title="Редактирай" igxIconButton="flat" (click)="openSportDialog(sportDialog, cell)">
                        <igx-icon>edit</igx-icon>
                    </button>
                </ng-template>
            </igx-column>
            <igx-column field="name" header="Име" [resizable]="true"></igx-column>
        </igx-grid>
        <igx-grid #levelsGrid primaryKey="id" [data]="selectedLevels | sorting" [width]="'100%'" [height]="'250px'"
            [emptyGridTemplate]="emptyGridTemplate" [rowDraggable]="true" igxDrop (dropped)="levelDropped($event)">
            <igx-grid-toolbar>
                <igx-grid-toolbar-title>Нива</igx-grid-toolbar-title>
                <igx-grid-toolbar-actions>
                    <button igxButton igxRipple (click)="openLevelDialog(levelDialog)">Добави ниво</button>
                </igx-grid-toolbar-actions>
            </igx-grid-toolbar>
            <igx-column width="50px" [editable]="false" [resizable]="false" [pinned]="true">
                <ng-template igxCell let-cell="cell">
                    <button title="Редактирай" igxIconButton="flat" (click)="openLevelDialog(levelDialog, cell)">
                        <igx-icon>edit</igx-icon>
                    </button>
                </ng-template>
            </igx-column>
            <igx-column width="50px" [editable]="false" [resizable]="false" [pinned]="true">
                <ng-template igxCell let-cell="cell">
                    <button title="Изтрий" igxIconButton="flat"
                        (click)="openDeleteLevelDialog(deleteLevelDialog, cell)">
                        <igx-icon>delete</igx-icon>
                    </button>
                </ng-template>
            </igx-column>
            <igx-column width="70px" field="name" header="Име" [resizable]="true"></igx-column>
            <igx-column field="description" header="Описание" [resizable]="true"></igx-column>
            <igx-column width="90px" field="public" header="Публично" [dataType]="'boolean'"
                [resizable]="true"></igx-column>
        </igx-grid>
    </div>
    <div class="cards">
        <igx-card style="width: 100%;" elevated>
            <igx-card-header>
                <h5 igxCardHeaderTitle>Глобални стойности по подразбиране</h5>
            </igx-card-header>
            <igx-card-content>
                <h6 *ngIf="!editGlobalDefaultValue">
                    Добави глобални стойности по подразбиране
                </h6>
                <ng-container *ngIf="editGlobalDefaultValue">
                    <igx-chip *ngIf="editGlobalDefaultValue.ageRange">от {{ editGlobalDefaultValue.ageRange.lower }} до
                        {{
                        editGlobalDefaultValue.ageRange.upper }}
                        години</igx-chip>
                    <igx-chip *ngIf="editGlobalDefaultValue.packageDuration">дни в пакета {{
                        editGlobalDefaultValue.packageDuration }}</igx-chip>
                    <igx-chip *ngIf="editGlobalDefaultValue.capacity">капацитет {{ editGlobalDefaultValue.capacity
                        }}</igx-chip>
                    <igx-chip *ngIf="editGlobalDefaultValue.price">цена {{ editGlobalDefaultValue.price }}</igx-chip>
                    <igx-chip *ngIf="editGlobalDefaultValue.deposit">депозит {{ editGlobalDefaultValue.deposit
                        }}</igx-chip>
                    <igx-chip *ngIf="editGlobalDefaultValue.depositDueDays">срок за депозит {{
                        editGlobalDefaultValue.depositDueDays }}</igx-chip>
                </ng-container>
            </igx-card-content>
            <igx-card-actions>
                <button *ngIf="!editGlobalDefaultValue" igxButton
                    (click)="openDefaultValuesDialog(addDefaultValuesDialog)" igxStart>Добави</button>
                <button *ngIf="editGlobalDefaultValue" igxButton
                    (click)="openDefaultValuesDialog(addDefaultValuesDialog)" igxStart>Редактирай</button>
            </igx-card-actions>
        </igx-card>
        <igx-card style="width: 100%;" elevated>
            <igx-card-header>
                <h5 igxCardHeaderTitle>Стойности по подразбиране за спорт</h5>
            </igx-card-header>
            <igx-card-content>
                <h6>
                    Стойности по подразбиране за спорт са изключени. Ще бъда преместени на ниво програма!
                </h6>
            </igx-card-content>
        </igx-card>
    </div>
    <div class="grids">
        <igx-grid #busesGrid primaryKey="id" [data]="buses | sorting" [width]="'100%'" [height]="'250px'"
            [emptyGridTemplate]="emptyBusGridTemplate">
            <igx-grid-toolbar>
                <igx-grid-toolbar-title>Бусове</igx-grid-toolbar-title>
                <igx-grid-toolbar-actions>
                    <button igxButton igxRipple (click)="openBusDialog(busDialog)">Добави бус</button>
                </igx-grid-toolbar-actions>
            </igx-grid-toolbar>
            <igx-column width="50px" [editable]="false" [resizable]="false" [pinned]="true">
                <ng-template igxCell let-cell="cell">
                    <button title="Редактирай" igxIconButton="flat" (click)="openBusDialog(busDialog, cell)">
                        <igx-icon>edit</igx-icon>
                    </button>
                </ng-template>
            </igx-column>
            <igx-column field="registrationNumber" header="Рег. №" [resizable]="true"></igx-column>
            <igx-column field="color" header="Цвят" [resizable]="true">
                <ng-template igxCell let-cell="cell">
                    <div [style.background-color]="cell.value ?? 'white'" [style.width]="'100%'" [style.height]="'100%'"
                        tabindex="0"></div>
                </ng-template>
            </igx-column>
            <igx-column field="capacity" header="Места" [resizable]="true" width="80px"></igx-column>
            <igx-column field="driver" header="Шофьор" [resizable]="true">
                <ng-template igxCell let-cell="cell">
                    {{ cell.value?.firstName }} {{ cell.value.lastName }}
                </ng-template>
            </igx-column>
        </igx-grid>
        <igx-grid #busStopsGrid primaryKey="id" [data]="busStops | sorting" [rowEditable]="true" [width]="'100%'"
            [height]="'250px'" [emptyGridTemplate]="emptyBusStopGridTemplate">
            <igx-grid-toolbar>
                <igx-grid-toolbar-title>Спирки</igx-grid-toolbar-title>
                <igx-grid-toolbar-actions>
                    <button igxButton igxRipple (click)="openBusStopDialog(busStopDialog)">Добави спирка</button>
                </igx-grid-toolbar-actions>
            </igx-grid-toolbar>
            <igx-column width="50px" [editable]="false" [resizable]="false" [pinned]="true">
                <ng-template igxCell let-cell="cell">
                    <button title="Редактирай" igxIconButton="flat" (click)="openBusStopDialog(busStopDialog, cell)">
                        <igx-icon>edit</igx-icon>
                    </button>
                </ng-template>
            </igx-column>
            <igx-column field="name" header="Име" [resizable]="true"></igx-column>
            <igx-column field="description" header="Описание" [resizable]="true"></igx-column>
        </igx-grid>
    </div>
    <div class="grids">
        <igx-card style="width: 100%;" elevated>
            <igx-card-content>
                <div class="column">
                    <button igxButton igxRipple (click)="openTransportSchemaDialog($event, transportSchemaDialog)">
                        Добави транспортна схема
                    </button>
                    <igx-accordion>
                        <igx-expansion-panel *ngFor="let schema of transportSchemas | sorting">
                            <igx-expansion-panel-header>
                                <igx-expansion-panel-title>
                                    <div style="display: flex; justify-content: space-between;">
                                        {{ schema.name }}
                                        <div>
                                            <button title="Редактирай схема" igxIconButton="flat"
                                                (click)="openTransportSchemaDialog($event, transportSchemaDialog, schema)">
                                                <igx-icon>edit</igx-icon>
                                            </button>
                                            <button title="Добави спирка" igxIconButton="flat"
                                                (click)="openStopSchemaDialog($event, stopDialog, schema)">
                                                <igx-icon>add</igx-icon>
                                            </button>
                                        </div>
                                    </div>
                                </igx-expansion-panel-title>
                                <igx-expansion-panel-description>
                                    {{ schema.description }}
                                </igx-expansion-panel-description>
                            </igx-expansion-panel-header>
                            <igx-expansion-panel-body>
                                <igx-list>
                                    <igx-list-item *ngIf="!schema.stops || schema.stops.length === 0">
                                        <span igxListLineTitle>
                                            Няма спирки. Добавете спирки към транспортната схема.
                                        </span>
                                    </igx-list-item>
                                    <igx-list-item #dragStop igxDrag igxDrop [ghostClass]="'drag_ghost_class'"
                                        *ngFor="let stop of schema.stops| sorting:sortPipeTrigger | hidden:false"
                                        (dragClick)="openStopSchemaDialog($event.originalEvent, stopDialog, schema, stop)"
                                        (dragStart)="stopDragStart(stop)" (ghostCreate)="stopDragGhostCreated(dragStop)"
                                        (enter)="stopEnter(stop)" (dragEnd)="stopDragEnd(dragStop, schema)">
                                        <span igxListLineTitle>
                                            {{ stop.busStop.name }} - {{ stop.busStop.description }}
                                        </span>
                                        <span igxListLineSubTitle>
                                            {{ stop.timeMorning | date: 'HH:mm' }} - {{ stop.timeEvening | date: 'HH:mm'
                                            }}
                                        </span>
                                        <igx-icon style="--size: 20px;" igxListAction>edit</igx-icon>
                                        <igx-icon style="--size: 20px;" igxListAction
                                            (click)="deleteStopSchemaDialog($event, deleteStopDialog, stop)">delete</igx-icon>
                                    </igx-list-item>
                                </igx-list>
                            </igx-expansion-panel-body>
                        </igx-expansion-panel>
                    </igx-accordion>
                </div>
            </igx-card-content>
            <igx-card-actions>
            </igx-card-actions>
        </igx-card>
        <igx-grid #templatesGrid primaryKey="id" [data]="this.templates | sorting">
            <igx-grid-toolbar>
                <igx-grid-toolbar-title>Шаблони</igx-grid-toolbar-title>
                <igx-grid-toolbar-actions>
                    <button igxButton igxRipple (click)="addTemplate(templateDialog)">Добави шаблон</button>
                </igx-grid-toolbar-actions>
            </igx-grid-toolbar>
            <igx-column width="65px" [editable]="false" [resizable]="false" [pinned]="true">
                <ng-template igxCell let-cell="cell">
                    <button title="Редактирай" igxIconButton="flat" (click)="editTemplate(cell, templateDialog)">
                        <igx-icon>edit</igx-icon>
                    </button>
                </ng-template>
            </igx-column>
            <igx-column field="name" header="Име" [resizable]="true"></igx-column>
            <igx-column field="context" header="Тип" [resizable]="true">
                <ng-template igxCell let-cell="cell">
                    {{parseTemplateContext(cell.value)}}
                </ng-template>
            </igx-column>
        </igx-grid>
    </div>
    <div class="grids">
        <igx-grid #paymentsGrid primaryKey="id" [data]="paymentSources | sorting" [width]="'100%'" [height]="'250px'">
            <igx-grid-toolbar>
                <igx-grid-toolbar-title>Видове плащания</igx-grid-toolbar-title>
                <igx-grid-toolbar-actions>
                    <button igxButton igxRipple (click)="openPaymentDialog(paymentDialog)">Добави нов вид
                        плащане</button>
                </igx-grid-toolbar-actions>
            </igx-grid-toolbar>
            <igx-column width="50px" [editable]="false" [resizable]="false" [pinned]="true">
                <ng-template igxCell let-cell="cell">
                    <button title="Редактирай" igxIconButton="flat" (click)="openPaymentDialog(paymentDialog, cell)">
                        <igx-icon>edit</igx-icon>
                    </button>
                </ng-template>
            </igx-column>
            <igx-column field="name" header="Име" [resizable]="true"></igx-column>
        </igx-grid>
    </div>
</div>

<igx-dialog #sportDialog>
    <igx-dialog-title>{{ dialogHeader }}</igx-dialog-title>
    <form [formGroup]="sportForm" (ngSubmit)="sportSubmit(sportDialog)">
        <igx-input-group class="input" type="border">
            <label igxLabel>Име</label>
            <input igxInput [igxTextSelection]="true" name="name" formControlName="name" />
        </igx-input-group>
        <div igxDialogActions>
            <button type="button" igxButton="outlined" (click)="sportDialog.close()">Откажи</button>
            <button igxButton="contained">{{ dialogHeader }}</button>
        </div>
    </form>
</igx-dialog>
<igx-dialog #levelDialog>
    <igx-dialog-title>{{ dialogHeader }}</igx-dialog-title>
    <form [formGroup]="levelForm" (ngSubmit)="levelSubmit(levelDialog)">
        <igx-input-group class="input" type="border">
            <label igxLabel>Име</label>
            <input igxInput [igxTextSelection]="true" name="name" formControlName="name" />
        </igx-input-group>
        <igx-input-group class="input" type="border">
            <label igxLabel>Описание</label>
            <input igxInput [igxTextSelection]="true" name="description" formControlName="description" />
        </igx-input-group>
        <igx-checkbox name="public" formControlName="public">публично</igx-checkbox>
        <div igxDialogActions>
            <button type="button" igxButton="outlined" (click)="levelDialog.close()">Откажи</button>
            <button igxButton="contained">{{ dialogHeader }}</button>
        </div>
    </form>
</igx-dialog>
<igx-dialog #deleteLevelDialog>
    <igx-dialog-title>{{ deleteDialogHeader }}</igx-dialog-title>
    <div igxDialogActions>
        <button igxButton="outlined" (click)="deleteLevelDialog.close()">Откажи</button>
        @if(levelToDelete) {
        <button igxButton="contained" (click)="deleteLevel(deleteLevelDialog)">Изтрий</button>
        }
    </div>
</igx-dialog>
<igx-dialog #addDefaultValuesDialog>
    <igx-dialog-title>{{ dialogHeader }}</igx-dialog-title>
    <form [formGroup]="defaultValuesForm" (ngSubmit)="modifyDefaultValue(addDefaultValuesDialog)">
        <div class="inputs">
            <igx-slider class="input slider" #slider name="ageRange" formControlName="ageRange" [type]="'range'"
                [showTicks]="true" [maxValue]="30" [minValue]="0" [primaryTicks]="4" [primaryTickLabels]="true"
                [secondaryTicks]="9" [secondaryTickLabels]="false" [step]="1" [lowerBound]="3" [upperBound]="50">
                <ng-template igxSliderTickLabel let-value>
                    {{ formatLabel(value) }}
                </ng-template>
            </igx-slider>
        </div>
        <div class="inputs">
            <igx-input-group class="input small" type="border">
                <label igxLabel>Капацитет</label>
                <input igxInput [igxTextSelection]="true" type="number" name="capacity" formControlName="capacity" />
            </igx-input-group>
            <igx-input-group class="input small" type="border">
                <label igxLabel>Цена</label>
                <input igxInput [igxTextSelection]="true" type="number" name="price" formControlName="price" />
            </igx-input-group>
            <igx-input-group class="input small" type="border">
                <label igxLabel>Дни в пакета</label>
                <input igxInput [igxTextSelection]="true" type="number" name="packageDuration"
                    formControlName="packageDuration" />
            </igx-input-group>
            <igx-input-group class="input small" type="border">
                <label igxLabel>Депозит</label>
                <input igxInput [igxTextSelection]="true" type="number" name="deposit" formControlName="deposit" />
            </igx-input-group>
            <igx-input-group class="input small" type="border">
                <label igxLabel>Срок за депозит</label>
                <input igxInput [igxTextSelection]="true" type="number" name="depositDueDays"
                    formControlName="depositDueDays" />
            </igx-input-group>
        </div>
        <div igxDialogActions>
            <button type="button" igxButton="outlined" (click)="addDefaultValuesDialog.close()">Откажи</button>
            <button igxButton="contained">{{ dialogHeader }}</button>
        </div>
    </form>
</igx-dialog>
<igx-dialog #busDialog>
    <igx-dialog-title>{{ dialogHeader }}</igx-dialog-title>
    <form [formGroup]="busForm" (ngSubmit)="busSubmit(busDialog)">
        <div class="inputs">
            <igx-input-group class="input small" type="border">
                <label igxLabel>Регистрационен №</label>
                <input igxInput [igxTextSelection]="true" name="registrationNumber"
                    formControlName="registrationNumber" />
            </igx-input-group>
            <igx-input-group class="input small" type="border">
                <igx-icon igxSuffix [igxToggleAction]="colorPicker">palette</igx-icon>
                <label igxLabel>Цвят</label>
                <input igxInput [igxTextSelection]="true" name="color" formControlName="color"
                    [style.color]="busForm.controls.color.value ?? 'white'"
                    [style.background]="busForm.controls.color.value ?? 'white'" />
            </igx-input-group>
            <github-picker igxToggle #colorPicker="toggle" [color]="busForm.controls.color.value ?? 'white'"
                [control]="githubControl" (colorChange)="colorSelected($event, colorPicker)">
            </github-picker>

            <igx-input-group class="input small" type="border">
                <label igxLabel>Места</label>
                <input igxInput [igxTextSelection]="true" type="number" name="capacity" formControlName="capacity" />
            </igx-input-group>
            <igx-select type="box" name="driver" formControlName="driver">
                <igx-select-item *ngFor="let driver of drivers | sorting | activeUser" [value]="driver.id">
                    {{driver.firstName}} {{driver.lastName}}
                </igx-select-item>
                <label igxLabel>Шофьор</label>
            </igx-select>
        </div>
        <div igxDialogActions>
            <button type="button" igxButton="outlined" (click)="busDialog.close()">Откажи</button>
            <button igxButton="contained">{{ dialogHeader }}</button>
        </div>
    </form>
</igx-dialog>
<igx-dialog #busStopDialog>
    <igx-dialog-title>{{ dialogHeader }}</igx-dialog-title>
    <form [formGroup]="busStopForm" (ngSubmit)="busStopSubmit(busStopDialog)">
        <igx-input-group class="input" type="border">
            <label igxLabel>Име</label>
            <input igxInput [igxTextSelection]="true" name="name" formControlName="name" />
        </igx-input-group>
        <igx-input-group class="input" type="border">
            <label igxLabel>Описание</label>
            <input igxInput [igxTextSelection]="true" name="description" formControlName="description" />
        </igx-input-group>
        <div igxDialogActions>
            <button type="button" igxButton="outlined" (click)="busStopDialog.close()">Откажи</button>
            <button igxButton="contained">{{ dialogHeader }}</button>
        </div>
    </form>
</igx-dialog>
<igx-dialog #transportSchemaDialog>
    <igx-dialog-title>{{ dialogHeader }}</igx-dialog-title>
    <form [formGroup]="transportSchemaForm" (ngSubmit)="transportSchemaSubmit(transportSchemaDialog)">
        <igx-input-group class="input" type="border">
            <label igxLabel>Име</label>
            <input igxInput [igxTextSelection]="true" name="name" formControlName="name" />
        </igx-input-group>
        <igx-input-group class="input" type="border">
            <label igxLabel>Описание</label>
            <input igxInput [igxTextSelection]="true" name="description" formControlName="description" />
        </igx-input-group>
        <div igxDialogActions>
            <button type="button" igxButton="outlined" (click)="transportSchemaDialog.close()">Откажи</button>
            <button igxButton="contained">{{ dialogHeader }}</button>
        </div>
    </form>
</igx-dialog>
<igx-dialog #stopDialog>
    <igx-dialog-title>{{ dialogHeader }}</igx-dialog-title>
    <form [formGroup]="busStopSchemaForm" (ngSubmit)="busStopSchemaSubmit(stopDialog)">
        <igx-select class="input" name="busStop" formControlName="busStop" type="border">
            <label igxLabel>Спирка</label>
            <igx-select-item *ngFor="let stop of busStops | sorting" [value]="stop.id">
                {{ stop.name }}
            </igx-select-item>
        </igx-select>
        <igx-time-picker class="input" name="timeMorning" formControlName="timeMorning" type="border"
            [inputFormat]="'HH:mm'">
            <label igxLabel>Сутрин</label>
        </igx-time-picker>
        <igx-time-picker class="input" name="timeEvening" formControlName="timeEvening" type="border"
            [inputFormat]="'HH:mm'">
            <label igxLabel>Вечер</label>
        </igx-time-picker>
        <div igxDialogActions>
            <button type="button" igxButton="outlined" (click)="stopDialog.close()">Откажи</button>
            <button igxButton="contained">{{ dialogHeader }}</button>
        </div>
    </form>
</igx-dialog>
<igx-dialog #deleteStopDialog>
    <igx-dialog-title>Потвърди изтриване на спирка</igx-dialog-title>
    <div igxDialogActions>
        <button type="button" igxButton="outlined" (click)="deleteStopDialog.close()">Откажи</button>
        <button igxButton="contained" (click)="deleteStop(deleteStopDialog)">Изтрий</button>
    </div>
</igx-dialog>
<igx-dialog #templateDialog>
    <div class="template">
        <igx-dialog-title>{{ dialogHeader }}</igx-dialog-title>
        <form [formGroup]="emailTemplateForm" (ngSubmit)="submitTemplate(templateDialog)" class="dialog">
            <div class="template-content">
                <div class="template-inputs">
                    <div class="template-heading">
                        <igx-input-group type="border">
                            <label igxLabel>Име</label>
                            <input igxInput formControlName="name" />
                        </igx-input-group>
                        <igx-simple-combo type="border" [data]="contexts" displayKey="readableName" valueKey="id"
                            formControlName="context" (selectionChanging)="contextChanged($event)"></igx-simple-combo>
                    </div>
                    <igx-input-group type="border">
                        <label igxLabel>Тема</label>
                        <input igxInput formControlName="subject" class="subject" />
                    </igx-input-group>
                    <div class="NgxEditor__Wrapper">
                        <ngx-editor-menu [editor]="editor"> </ngx-editor-menu>
                        <ngx-editor #templateEditor class="data" [editor]="editor" formControlName="text"></ngx-editor>
                    </div>
                </div>
                <div class="template-cards">
                    @if (context) {
                        <h5>{{ context.readableName }}</h5>
                        @if (context.variables.length > 0) {
                            <h6>Променливи</h6>
                        }
                        @for (variable of context.variables; track variable.id) {
                            <igx-chip id="{{variable.id}}" selectable="false" (chipClick)="variableClick($event)">{{ variable.readableName }}</igx-chip>
                        }
                        @if (context.conditions.length > 0) {
                            <h6>Условия</h6>
                        }
                        @for (condition of context.conditions; track condition.id) {
                            <igx-chip id="{{condition.id}}" selectable="false" (chipClick)="conditionClick($event)">{{ condition.readableName }}</igx-chip>
                        }
                    }
                </div>
            </div>
            <div igxDialogActions>
                <button type="button" igxButton="outlined" (click)="templateDialog.close()">Откажи</button>
                <button igxButton="contained">{{ dialogHeader }}</button>
            </div>
        </form>
    </div>
</igx-dialog>
<igx-dialog #paymentDialog>
    <igx-dialog-title>{{ dialogHeader }}</igx-dialog-title>
    <form [formGroup]="paymentForm" (ngSubmit)="paymentSubmit(paymentDialog)">
        <igx-input-group class="input" type="border">
            <label igxLabel>Име</label>
            <input igxInput [igxTextSelection]="true" name="name" formControlName="name" />
        </igx-input-group>
        <div igxDialogActions>
            <button type="button" igxButton="outlined" (click)="paymentDialog.close()">Откажи</button>
            <button igxButton="contained">{{ dialogHeader }}</button>
        </div>
    </form>
</igx-dialog>

<ng-template #emptyGridTemplate>
    <div class="emty-template-wrapper">{{ emptyTemplateMessage }}</div>
</ng-template>
<ng-template #emptyBusGridTemplate>
    <div class="emty-template-wrapper">Добавете бусове</div>
</ng-template>
<ng-template #emptyBusStopGridTemplate>
    <div class="emty-template-wrapper">Добавете спирки</div>
</ng-template>
